import { ELEM_TYPES } from './constants/ElementTypes'
import _ from 'lodash'
import { LIST_BASED_FIELDS } from '../constants/LIST_BASED_FIELDS'
import { getElementDataRoot } from '../constants/getElementDataRoot'
import { Map } from 'immutable'

export const getElementInfo = (action, keyPath, retState, index, isBtnRepeat, isPossibleRepeat) => {
  let isList = false
  let elemType = action.get('elemType')

  if (elemType === ELEM_TYPES.SURVEY_LIST) {
    isList = true
  } else if (elemType === ELEM_TYPES.FORM_FIELD) {
    let elUID = isBtnRepeat && !_.isNil(index) && isPossibleRepeat ? keyPath[2] : keyPath[1]

    const elem = retState.getIn(
      [
        ...getElementDataRoot(['Header', 'Footer'].includes(keyPath[0]) ? 'project' : retState.get('page')),
        'elements',
        elUID,
      ],
      Map()
    )

    if (elem.getIn(['props', 'control'])) {
      elemType = elem.getIn(['props', 'control'])
    }

    if (
      LIST_BASED_FIELDS.includes(elemType) ||
      (elemType === ELEM_TYPES.CHECKBOX && elem.getIn(['props', 'source'], 'single') !== 'single')
    ) {
      isList = true
    }
  }

  return { isList, elemType }
}
